var _filter, _rect, _text, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComparison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcpGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2aGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowComp"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 4,
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 40,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: "bold"
  }, "MCP vs A2A Comparison")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -140,
    width: 300,
    height: 280,
    rx: 15,
    fill: "#1e293b",
    stroke: "#3b82f6",
    strokeWidth: 2,
    filter: "url(#shadowComp)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -140,
    width: 300,
    height: 50,
    rx: 15,
    fill: "url(#mcpGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -105,
    width: 300,
    height: 15,
    fill: "url(#mcpGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -108,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 18
  }, "MCP"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: 0,
    r: 20,
    fill: "#3b82f6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "20;22;20",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: -40,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Agent"), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: 0,
    x2: 25,
    y2: 0,
    stroke: "#22c55e",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,50;40,50",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30,0 22,-5 22,5",
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: -15,
    width: 40,
    height: 30,
    rx: 5,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;1;0.7",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Tool")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Stateless operations")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "One-way communication")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Tool execution")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 110)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Low complexity")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 220)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -120,
    x2: 0,
    y2: 120,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "8,8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 6,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 14
  }, "VS"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -140,
    width: 300,
    height: 280,
    rx: 15,
    fill: "#1e293b",
    stroke: "#8b5cf6",
    strokeWidth: 2,
    filter: "url(#shadowComp)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -140,
    width: 300,
    height: 50,
    rx: 15,
    fill: "url(#a2aGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -105,
    width: 300,
    height: 15,
    fill: "url(#a2aGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -108,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 18
  }, "A2A"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: 0,
    r: 20,
    fill: "#8b5cf6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "20;22;20",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: -40,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent1"), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: -5,
    x2: 25,
    y2: -5,
    stroke: "#8b5cf6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,50;40,50",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "28,-5 22,-9 22,-1",
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 5,
    x2: -15,
    y2: 5,
    stroke: "#ec4899",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,50;40,50",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "-18,5 -12,1 -12,9",
    fill: "#ec4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 0,
    r: 20,
    fill: "#ec4899"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "20;22;20",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Agent2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Stateful conversations")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Two-way communication")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Collaboration")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130, 110)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 5,
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "High complexity")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 370)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -15,
    width: 120,
    height: 30,
    rx: 15,
    fill: "#3b82f6",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#60a5fa",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "Agent &#8594; Tool"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 370)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -15,
    width: 120,
    height: 30,
    rx: 15,
    fill: "#8b5cf6",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "Agent &#8596; Agent"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparison);
export default __webpack_public_path__ + "static/media/comparison.67e6a66e854d0e95c9958791162e87ff.svg";
export { ForwardRef as ReactComponent };